module.exports = {"540623100":"聂荣镇","540623201":"尼玛乡","540623203":"色庆乡","540623205":"桑荣乡","540623206":"下曲乡","540623207":"白雄乡","540623208":"索雄乡","540623210":"当木江乡","540623211":"查当乡","540623212":"永曲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540623.json
// module id = 2874
// module chunks = 0